import { apiClient } from './client';
import { API_ENDPOINTS } from '@/constants/api';

/**
 * Тип запроса для массовой отправки сообщений
 */
export type BroadcastMessageRequest = {
  message: string;
  chatIds?: number[];
};

/**
 * Тип ответа при массовой отправке сообщений
 */
export type BroadcastMessageResponse = {
  success: boolean;
  message: string;
  sent: number;
  failed: number;
  errors?: Array<{ chatId: number; error: string }>;
};

/**
 * API методы для работы с Telegram
 */
export const telegramApi = {
  /**
   * Отправляет массовое сообщение всем пользователям Telegram
   * @param data - Данные для отправки (сообщение и опционально список chatIds)
   * @returns Promise с результатом отправки
   */
  broadcast: async (data: BroadcastMessageRequest): Promise<BroadcastMessageResponse> => (
    apiClient.post<BroadcastMessageResponse>(API_ENDPOINTS.ADMIN_TELEGRAM_BROADCAST, data)
  ),
};
